import { useCallback, useEffect, useState } from "react"
import { useLoading } from "../../context/LoadingContext"
import { apiCheckBalanceTopup, apiGetListTopUpConfig } from "../../api"
import { formatCurrency } from "../../utils/string-utils"
import { Select, Space, Tag } from "antd"
import { Line } from "react-chartjs-2"

export const renderOrderStatus = (state: string) => {
    const style: object = { width: 100, textAlign: 'center', marginRight: 0 }
    if (state === 'COMPLETED') return <Tag style={style} color="#9b9b05">Hoàn thành</Tag>
    if (state === 'CANCELLED') return <Tag style={style} color="#c93c3c">Đã huỷ bỏ</Tag>
    if (state === 'CREATED') return <Tag style={style} color="#2faac6">Đã tạo</Tag>
    if (state === 'PROCESSING') return <Tag style={style} color="#1d9a46">Đang xử lý</Tag>
    if (state === 'LOCKED') return <Tag style={style} color="#c93c3c">Đã khoá</Tag>
    return <Tag style={style} color="#ff6f00">Đang nạp excel</Tag>
}

export const renderStatus = (state: string) => {
    const style: object = { width: 100, textAlign: 'center', marginRight: 0 }
    if (state === 'SUCCESS') return <Tag style={style} color="#9b9b05">Thành công</Tag>
    if (state === 'FAIL') return <Tag style={style} color="#c93c3c">Thất bại</Tag>
    if (state === 'ERROR') return <Tag style={style} color="#c93c3c">Lỗi</Tag>
    if (state === 'TIMEOUT') return <Tag style={style} color="#cb28df">Chưa rõ kết quả</Tag>
    if (state === 'PROCESSING') return <Tag style={style} color="#1d9a46">Đang xử lý</Tag>
    return <Tag style={style} color="#2faac6">Đã tạo</Tag>
}

export default function ManagementTopUpOverview() {
    const [networkOptions, setNetworkOptions] = useState<{ label: string, value: string }[]>([])
    const [balance, setBalance] = useState<any>()
    const [network, setNetwork] = useState('')
    const { setIsLoading } = useLoading()

    const fetchTopUpConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListTopUpConfig({})
            if (data?.topUpConfigs.length > 0) {
                setNetworkOptions(data.topUpConfigs?.map((item: any) => ({ label: `${item.network} (${item.username})`, value: item.network })) || [])
                setNetwork(data.topUpConfigs?.[0]?.network || '')
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchData = useCallback(async () => {
        try {
            if (!network) return
            setIsLoading(true)
            const { data } = await apiCheckBalanceTopup({ network })
            setBalance(data || {})
        } catch (error) {
            setBalance({})
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [setIsLoading, network])

    useEffect(() => {
        if (networkOptions.length === 0) {
            fetchTopUpConfig()
        }
        fetchData()
    }, [fetchData])

    const data = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [65, 59, 80, 81, 56, 55, 40],
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,0.2)',
            },
        ],
    }

    return (
        <div>
            {networkOptions.length > 0 && (
                <Space>
                    <div>Chọn tài khoản: </div>
                    <Select
                        style={{ minWidth: 170 }}
                        options={networkOptions}
                        value={network}
                        onChange={(value) => setNetwork(value)}
                    />
                </Space>
            )}
            <h2>Số dư: {formatCurrency(balance?.balance || 0)}</h2>
            <Line data={data} />
        </div>
    )
}
